import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { Place } from '@app/entities/place';
import { fetchPlacesSuccessAction } from '@app/store/actions/global.actions';

export interface PlaceState extends EntityState<Place> {}

export const placeAdapter: EntityAdapter<Place> = createEntityAdapter<Place>();

export const initialPlaceState: PlaceState = placeAdapter.getInitialState({});

const reducer = createReducer(
  initialPlaceState,
  on(fetchPlacesSuccessAction, (state, { places }) => placeAdapter.setAll(places, state))
);

export function placesReducer(state: PlaceState, action: Action): PlaceState {
  return reducer(state, action);
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = placeAdapter.getSelectors();
